import type { Payment } from '@klear/payment/payment'

export function byPaymentCreatedAtDesc(a: { payment: Payment }, b: { payment: Payment }): number {
  const left = a.payment.createdAt
  const right = b.payment.createdAt
  if (left == null) return right == null ? 0 : 1
  if (right == null) return -1
  if (left.equals(right)) return 0
  return left.isAfter(right) ? -1 : 1
}
